export const MSG = {
  HOME: {
    TITLE: '비교날씨',
  },
};
